/**
 * Le Vanilla shell — the active camera fills the shared Vanilla canvas while
 * navigation, event details, and the camera rail float above it.
 *
 * Le Vanilla + Map uses the same VanillaCanvasFrame. Its only structural
 * addition is a map layer and a map/camera canvas toggle.
 *
 * Slots:
 *   - topbar           : brand logo + nav icons + avatar (Topbar primitive)
 *   - player           : full-canvas MainPlayer
 *   - below_player     : floating event details panel
 *   - sidebar          : floating camera / event context panel
 *   - mobile_switcher  : bottom-pinned About/Cameras toggle (MobileModeSwitcher)
 *
 * Slots not in the layout JSON simply render empty — the shell tolerates
 * partial layouts so the Director can iterate without breaking the page.
 */

import { registerShell, type ShellProps } from '../../layout'
import { VanillaCanvasFrame } from './VanillaCanvasFrame'
import './LeVanilla.css'

function LeVanillaShell({ slots }: ShellProps) {
  return (
    <VanillaCanvasFrame
      className="lv-shell-video"
      slots={slots}
      canvas={(
        <div className="lv-player-wrap">
          {slots.player}
          {slots.player_overlay && (
            <div className="lv-player-overlay">{slots.player_overlay}</div>
          )}
        </div>
      )}
    />
  )
}

registerShell('le_vanilla', LeVanillaShell)

export { LeVanillaShell }
